// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jHmK","title":"styles_title__3s3Ci"};